/* unplugin-vue-components disabled */import { render } from "./FooterCustom.vue?vue&type=template&id=04a9bb1c&scoped=true"
import script from "./FooterCustom.vue?vue&type=script&lang=js"
export * from "./FooterCustom.vue?vue&type=script&lang=js"

import "./FooterCustom.vue?vue&type=style&index=0&id=04a9bb1c&scoped=true&lang=css"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\en\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a9bb1c"]])

export default __exports__